// apps/web/src/helpers/rnBridge.js

const canPost =
    typeof window !== "undefined" &&
    window?.ReactNativeWebView &&
    typeof window.ReactNativeWebView.postMessage === "function";

/**
 * Safe WebView bridge postMessage.
 * Works only inside the native WebView wrapper.
 */
export const postToNative = (message) => {
    if (!canPost) return false;

    try {
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
        return true;
    } catch (e) {
        // swallow errors to avoid breaking login flow
        return false;
    }
};

/**
 * Convenience: send auth payload to native.
 */
export const postAuthToNative = (authUser, apiBaseUrl) =>
    postToNative({ type: "CRMIT_AUTH", authUser, apiBaseUrl });


/**
 * Convenience: tell native user logged out.
 */
export const postLogoutToNative = () =>
    postToNative({ type: "CRMIT_LOGOUT" });
